<div class="under-maintain-container">
    <div class="text-container">
        <h4 for="">OneStar Game is Under Maintenance... <span class="blink_me" style="font-size: 22px !important;">
            (Estimate duration time: about 30 minutes...)
        </span></h4>
        
    </div>
</div>